var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_navigation",
    "data-name": "icon navigation",
    d: "M17.5,0H2.5A2.5,2.5,0,0,0,0,2.5v15A2.5,2.5,0,0,0,2.5,20h15A2.5,2.5,0,0,0,20,17.5V2.5A2.5,2.5,0,0,0,17.5,0ZM14.1,8.652a.835.835,0,0,1-.77.514h-2.5V15a.833.833,0,1,1-1.667,0V9.167h-2.5a.833.833,0,0,1-.589-1.423L9.411,4.411a.832.832,0,0,1,1.178,0l3.333,3.333A.833.833,0,0,1,14.1,8.652Zm0,0",
    fill: "#d6d6d6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/navigation.d140f2b3fce16d06945ba8658bc10ed6.svg";
export { ForwardRef as ReactComponent };